class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    if (hasRebuyCart()) {
      showRebuySmartCart();
      return;
    }

    this.drawer = this.drawer || this.closest('cart-drawer') || document.querySelector('cart-drawer');

    if (!this.drawer || typeof this.drawer.openMenuDrawer !== 'function') return;

    const detailsElement = this.drawer.querySelector('details');

    if (!detailsElement) return;

    const isVisiblyOpen =
      detailsElement.classList.contains('menu-opening') ||
      document.body.classList.contains('mini-cart--open') ||
      document.body.classList.contains('mini-cart--opening');

    if (isVisiblyOpen) return;

    detailsElement.classList.remove('menu-closing');
    document.body.classList.remove('mini-cart--closing');

    this.drawer.openMenuDrawer(detailsElement.querySelector('summary'));

    setTimeout(() => {
      if (typeof setHeaderBottomPosition === 'function') {
        setHeaderBottomPosition();
      }
    }, 250);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    const sections = parsedState && parsedState.sections;

    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      const html = sections && sections[section.id];

      if (!el || !html) return;

      try {
        el.innerHTML = this.getSectionInnerHTML(html, section.selector);
      } catch (error) {
        console.error(error);
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const el = parsed.querySelector(selector);

    return el ? el.innerHTML : html;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

function hasRebuyCart() {
  return Boolean(
    document.getElementById('rebuy-cart') ||
    document.querySelector('.rebuy-cart') ||
    document.body.classList.contains('smart-cart--enabled')
  );
}

// Rebuy does not reliably intercept JSON POST /cart/add in Safari, so the
// Smart Cart can stay closed/empty after ATC even though Shopify added the item.
function showRebuySmartCart() {
  const Rebuy = window.Rebuy;
  if (!Rebuy?.SmartCart || typeof Rebuy.SmartCart.show !== 'function') return;

  let shown = false;
  const show = () => {
    if (shown) return;
    shown = true;
    Rebuy.SmartCart.skip_open = false;
    Rebuy.SmartCart.show();
  };

  if (typeof Rebuy.Cart?.fetchShopifyCart === 'function') {
    try {
      const result = Rebuy.Cart.fetchShopifyCart(show);
      if (result && typeof result.then === 'function') {
        result.then(show).catch(show);
      }
    } catch (error) {
      show();
    }

    setTimeout(show, 600);
    return;
  }

  show();
}

window.showRebuySmartCart = showRebuySmartCart;

function isiPhone() {
  return /iPhone/.test(navigator.userAgent) && !window.MSStream;
}

if (isiPhone()) {
  const cartDrawer = document.querySelector('cart-drawer'); // Update this selector!

  function resizeCartDrawer() {
    if (!cartDrawer) return;

    const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    cartDrawer.style.height = vh + 'px';
  }

  // Resize when drawer opens (observe or hook into open event)
  const observer = new MutationObserver(() => {
    const isVisible = cartDrawer && window.getComputedStyle(cartDrawer).display !== 'none';
    if (isVisible) {
      resizeCartDrawer();
    }
  });

  if (cartDrawer) {
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  // Also resize on scroll and resize (when browser UI shows)
  //window.addEventListener('resize', resizeCartDrawer);
 // window.addEventListener('scroll', resizeCartDrawer);
}

